<template>
  <div class="container">
    <p class="heading-secondary-main">
      FCB Visual Analytics
    </p>
    <div class="reference__toggler">
      <div class="reference__toggler--inner">
        <div class="reference__dot" :style="{ left: toggleButtonPlace }"></div>
      </div>
      <div
        class="reference__toggler-item"
        :class="{ active: selectedGroupId === 2 }"
        @click="toggleButton(2)"
      >
        Бизнес-кредитование
      </div>
      <div
        class="reference__toggler-item"
        :class="{ active: selectedGroupId === 1 }"
        @click="toggleButton(1)"
      >
        Розничное кредитование
      </div>
    </div>
    <!-- <p class="mb--4 mt--4">
      <span class="bold">Demo </span> – это отчеты, которые не содержат реальных
      данных и представлены в качестве примера. Отчеты с реальными данными вы
      можете приобрести по
      <span class="text--link bold text--blue" @click="gotoTariffs"
        >ссылке.</span
      >
    </p> -->
    <div class="card__list">
      <template v-if="isLoading">
        <ReportCardPlaceholder
          v-for="item in 8"
          :key="item"
        ></ReportCardPlaceholder>
      </template>
      <template v-else>
        <ReportCard
          v-for="report in filteredReports"
          :key="report.id"
          :report="report"
        ></ReportCard>
      </template>
    </div>
    <UnavailableReportForm
      :report-type="selectedGroupId"
    ></UnavailableReportForm>
    <RequestReportForm :request-type="4">
      <p class="paragraph  mb--2">
        Заполните форму ниже, чтобы узнать условия получения дополнительной
        аналитики:
      </p>
    </RequestReportForm>
  </div>
</template>

<script>
import { actionTypes } from "@/store/modules/report";
import { mapState } from "vuex";
import ReportCard from "@/components/common/report-card/ReportCard.vue";
import ReportCardPlaceholder from "@/components/common/report-card/ReportCardPlaceholder.vue";
import UnavailableReportForm from "@/views/visual-analytics/components/UnavailableReportForm.vue";
import RequestReportForm from "@/views/visual-analytics/components/RequestReportForm.vue";
export default {
  components: {
    ReportCard,
    UnavailableReportForm,
    RequestReportForm,
    ReportCardPlaceholder,
  },
  data() {
    return {
      selectedGroupId: 2,
      filteredReports: null,
    };
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.report.isLoading,
      reports: (state) => state.report.data,
      error: (state) => state.report.error,
    }),
    toggleButtonPlace() {
      return this.selectedGroupId === 2 ? "23%" : "73%";
    },
  },
  mounted() {
    this.getReportList();
  },
  methods: {
    getReportList() {
      this.$store.dispatch(actionTypes.getReportListAction).then(() => {
        this.getFilteredReport(this.selectedGroupId);
      });
    },
    toggleButton(value) {
      this.selectedGroupId = value;
      this.getFilteredReport(value);
    },
    getFilteredReport(group_id) {
      this.filteredReports = this.reports.data.filter(
        (report) => report.group === group_id
      );
    },
    getSelectedReport() {
      return this.reports.data.filter(
        (report) => report.group === this.selectedGroupId
      );
    },
    gotoTariffs() {
      this.$router.push({ name: "Tariffs" });
    },
  },
};
</script>

<style lang="scss" scoped>
.reference {
  background-color: #fff;
  max-width: 1110px;
  width: 100%;
  margin: auto;
  padding: 0 15px;
  &__toggler {
    max-width: 400px;
    width: 100%;
    border-radius: 30px 30px 30px 30px;
    border: 1px solid #0082be;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: inherit;
    margin-bottom: 6rem;
    &--inner {
      background: #ffffff;
      border: 1px solid #e9e9e9;
      width: 6rem;
      height: 3rem;
      box-shadow: 4px 4px 15px rgba(58, 117, 102, 0.2);
      border-radius: 10rem;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    &-item {
      width: 50%;
      font-size: 14px;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      color: #9c9898;
      padding: 1.5rem 4rem;
      height: 60px;
      cursor: pointer;
    }
  }
  &__dot {
    width: 2.2rem;
    height: 2.2rem;
    background: #0082be;
    border-radius: 10rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.card {
  &__list {
    margin-bottom: 10rem;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(256px, 1fr));
    grid-gap: 15px;
  }
}

.active {
  background: #0082be;
  color: white;
}
</style>
